import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useEffect, useState } from 'react';
import { Gauge } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

interface PlaybackSpeedMenuProps {
  currentSpeed: number;
  onSpeedChange: (speed: number) => void;
  className?: string;
  color?: string;
}

const speedOptions = [
  { value: 0.5, label: '0.5x' },
  { value: 0.75, label: '0.75x' },
  { value: 1, label: '1x' },
  { value: 1.25, label: '1.25x' },
  { value: 1.5, label: '1.5x' },
  { value: 2, label: '2x' }
];

export const PlaybackSpeedMenu: React.FC<PlaybackSpeedMenuProps> = ({
  currentSpeed,
  onSpeedChange,
  className = "",
  color
}) => {
  useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  // Espelha a velocidade ativa para destacar o item selecionado mesmo quando
  // o parent não atualiza a prop após o clique (ex.: setPlaybackSpeed apenas
  // seta video.playbackRate sem persistir em features).
  const [activeSpeed, setActiveSpeed] = useState<number>(currentSpeed);

  useEffect(() => {
    setActiveSpeed(currentSpeed);
  }, [currentSpeed]);

  const currentSpeedLabel = speedOptions.find(option => option.value === activeSpeed)?.label || '1x';

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`h-8 w-8 p-0 hover:bg-white/20 ${className}`}
          style={color ? { color } : undefined}
          aria-label={translateInterfaceText("Velocidade atual: {value0}", { value0: (currentSpeedLabel) })}
        >
          <Gauge className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="center"
        className="min-w-[80px] bg-black/90 border-white/20"
      >
        {speedOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => {
              onSpeedChange(option.value);
              setActiveSpeed(option.value);
              setIsOpen(false);
            }}
            className={`
              text-white hover:bg-white/20 cursor-pointer justify-center
              ${activeSpeed === option.value ? 'bg-white/10' : ''}
            `}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};